import { API } from '../../../common/api/constants';

// ПОЛУЧИТЬ СПИСОК СОТРУДНИКОВ GET
export const GET_EMPLOYEES = `${API}/employees/profile/`;

export const UPDATE_EMPLOYEE = `${API}/employees/user/update_and_fill/`;
export const CREATE_EMPLOYEE = `${API}/employees/user/create_and_fill/`;

// ЗАГРУЗИТЬ ФОТОГРАФИ ПОЛЬЗОВАТЕЛЯ
export const UPLOAD_EMPLOYEE_PHOTO = `${API}/employees/profile/upload/photo`;

// ЗАГРУЗИТЬ ФОТОГРАФИЮ ВОДИТЕЛЬСКОГО
export const UPLOAD_DRIVER_LICENSE_PHOTO_FRONT = `${API}/employees/driver/license/upload/photo_front`;
export const UPLOAD_DRIVER_LICENSE_PHOTO_BACK = `${API}/employees/driver/license/upload/photo_back`;

// ИЗМЕНИТЬ СТАТУС СОТРУДНИКА
export const UPDATE_EMPLOYEE_STATUS = `${API}/employees/profile/{profile_id}/employee/{employee_id}/profile_status/{profile_status_key}`;

// ПРОВЕРКА СУЩЕСТВОВАНИЕ ПОЛЬЗОВАТЕЛЯ ПО НОМЕРУ ТЕЛЕФОНА
export const CHECK_USER_BY_PHONE_NUMBER = `${API}/authorization/user/check/phone/{phone}`;
